/* eslint-disable camelcase */

import { isUpdateFunnelSegmentEventsActivated } from '~/util/optimizelyHelpers';
import { getUserUuid } from '~/util/getUserUuid';
import productType from '~/util/productType';
import backendAnalyticsTrack from './util/backendAnalyticsTrack';
import frontendAnalyticsTrack from './util/frontendAnalyticsTrack';
import {
  CLICKED_BUTTON,
  CLICKED_LINK,
  NAVIGATOR_STARTED_ACTION,
  NAVIGATOR_STARTED,
  NAVIGATOR_COMPLETED_ACTION,
  NAVIGATOR_COMPLETED,
  NAVIGATOR_STEP_STARTED,
  NAVIGATOR_STEP_COMPLETED,
  EXPERIMENT_VIEWED,
  ACCOUNT_CREATED_ACTION,
} from './constants';

export const trackClickedButton = (opts: Record<string, unknown> = {}) => {
  frontendAnalyticsTrack(CLICKED_BUTTON, opts);
};

export const trackClickedLink = (href: string) => {
  frontendAnalyticsTrack(CLICKED_LINK, { href });
};

export const trackNavigatorStarted = (product: string, opts: Record<string, unknown> = {}) => {
  backendAnalyticsTrack(NAVIGATOR_STARTED_ACTION, [product]);
  frontendAnalyticsTrack(NAVIGATOR_STARTED, opts);
};

export const trackNavigatorCompleted = (opts: Record<string, unknown> = {}) => {
  backendAnalyticsTrack(NAVIGATOR_COMPLETED_ACTION);
  frontendAnalyticsTrack(NAVIGATOR_COMPLETED, opts);
};

export const trackNavigatorStepStarted = (step: string, opts: Record<string, unknown> = {}) => {
  const additionalProps = addEventProperties(<EventPropertiesArgs>opts);

  frontendAnalyticsTrack(NAVIGATOR_STEP_STARTED, { step, ...additionalProps });
};

export const trackNavigatorStepCompleted = (step: string, opts: Record<string, unknown> = {}) => {
  const additionalProps = addEventProperties(<EventPropertiesArgs>opts);

  frontendAnalyticsTrack(NAVIGATOR_STEP_COMPLETED, { step, ...additionalProps });
};

export const trackAccountCreated = (...opts: any) => {
  backendAnalyticsTrack(ACCOUNT_CREATED_ACTION, ['home_and_auto', ...opts]);
};

export const trackExperimentViewed = (opts: Record<string, unknown> = {}) => {
  if (!(window as any).FRONTLINE) {
    return;
  }

  const { branch, experiment } = (window as any).FRONTLINE;

  if (!experiment) {
    return;
  }

  const properties = {
    experiment_name: experiment,
    variation_name: branch,
    campaign_name: 'home-and-auto-branch-experiment',
  };

  frontendAnalyticsTrack(EXPERIMENT_VIEWED, { ...properties, ...opts });
};

export const trackRentersNavigatorStarted = () => {
  backendAnalyticsTrack(NAVIGATOR_STARTED_ACTION, ['renters']);
  frontendAnalyticsTrack(NAVIGATOR_STARTED, { vertical: 'Renters' });
};
interface EventPropertiesArgs extends Record<string, unknown> {
  application: ApplicationQuery;
  currentUserProfile: UserProfileQuery;
}

export const addEventProperties = (eventProperties: EventPropertiesArgs) => {
  const { application, currentUserProfile, ...originalEventProperties } = eventProperties;

  if (isUpdateFunnelSegmentEventsActivated(getUserUuid())) {
    const referenceId = application?.referenceId;
    const authenticated = !!currentUserProfile?.email;
    const product = productType(application);

    const addedEventProperties = {
      ...originalEventProperties,
      referenceId,
      authenticated,
      vertical: product,
    };

    return addedEventProperties;
  }

  return originalEventProperties;
};
